export class CodeExpiredError extends Error {
  public constructor() {
    super()

    this.message = 'errors.codeExpired'
  }
}
